import {IControllers, Loader} from "../loader";
import {IController} from "../controller";

export class LoginLoader extends Loader {
    /* STATIC */
    public static override async build(): Promise<IControllers> {
        const onload: IController[] = [];
        //if (window.location.pathname.endsWith(".html")) {
            const [
                {Auth},
            ] = await Promise.all([
                import(/* webpackChunkName: "encuesta" */ `../controllers/firebase/auth`),
            ]);

            onload.push(...[
                Auth,
            ])
        //}
        return {
            ...await super.build(),
            onload,
        };
    }

    /* INSTANCE */
}
